var exports = {
  "kL": "xa15a2ab7--6b331a--container",
  "YL": "xa15a2ab7--6b331a--tooltip",
  "Kk": "xa15a2ab7--6b331a--icon",
  "Wo": "xa15a2ab7--6b331a--tooltip-value",
  "q9": "xa15a2ab7--6b331a--price",
  "h_": "xa15a2ab7--6b331a--description",
};

module.exports = exports;
